import type { CommunityMemberComputed } from '~/interfaces/community';

import { useCommunityMembership } from './useCommunityMembership';

export const useCanMessageMember = (target: { dms_enabled: boolean; computed?: CommunityMemberComputed }): boolean => {
  const { isMessagesEnabled, permissions } = useCommunityMembership();

  return isMessagesEnabled && target.dms_enabled && target.computed?.blocking !== true && permissions.canInteract;
};
